const getEncodedRequestFilters = ({ requestFilters = [] }) => {
  const encodedRequestFilters = [];
  requestFilters.forEach(({ id, value }) => {
    const filter = {};

    filter.id = id;
    if (typeof value !== "string") {
      filter.value = value;
    } else {
      filter.value = value?.replace(/\+/g, "%2B"); // Encode the '+' sign
    }

    encodedRequestFilters.push(filter);
  });

  return encodedRequestFilters;
};

export default getEncodedRequestFilters;
